function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (_ref) {
  var colors = _ref.colors,
      mediaQueries = _ref.mediaQueries,
      sizes = _ref.sizes;
  return {
    container__topMargin: {
      marginTop: '10px'
    },
    container__bottomMargin: {
      marginBottom: '25px'
    },
    wrapper__half: {
      minWidth: '50%',
      width: '50%'
    },
    wrapper__xSmall: {
      minWidth: '160px'
    },
    wrapper__small: {
      minWidth: '250px'
    },
    wrapper__medium: {
      minWidth: '320px'
    },
    wrapper__large: {
      minWidth: '400px'
    },
    wrapper__full: {
      minWidth: '100%'
    },
    wrapper: _defineProperty({
      position: 'relative',
      display: 'inline-block',
      border: '1px solid transparent',
      borderBottom: "2px solid ".concat(colors.inputBorder),
      cursor: 'text',
      transition: 'border-color .2s',
      height: sizes.inputHeight,
      backgroundColor: colors.white,
      paddingBottom: 0
    }, mediaQueries.breakpointSmall, {
      minWidth: '100%'
    }),
    wrapper__padded: {
      paddingLeft: '5px',
      paddingTop: '18px',
      paddingRight: '40px'
    },
    wrapper__focused: {
      borderBottom: "solid 2px ".concat(colors.primary)
    },
    wrapper__error: {
      borderBottom: "solid 2px ".concat(colors.error)
    },
    wrapper__bordered: {
      borderTop: "solid 1px ".concat(colors.inputBorder),
      borderLeft: "solid 1px ".concat(colors.inputBorder),
      borderRight: "solid 1px ".concat(colors.inputBorder)
    },
    wrapper__borderRight: {
      borderRight: "solid 1px ".concat(colors.inputBorder)
    },
    wrapper__disabled: {
      opacity: 0.6
    },
    wrapper__autoHeight: {
      height: 'auto'
    },
    indicator: {
      position: 'absolute',
      top: '50%',
      right: '8px',
      transform: 'translateY(-50%)',
      borderRadius: '20px',
      padding: '1px',
      border: "2px solid ".concat(colors.primary),
      lineHeight: '8px',
      backgroundColor: colors.primary,
      pointerEvents: 'none',
      '& svg': {
        fill: colors.white,
        width: '10px',
        height: '10px'
      }
    },
    indicator__error: {
      border: "2px solid ".concat(colors.error),
      backgroundColor: 'transparent',
      '& svg': {
        fill: colors.error
      }
    },
    label__simplified: {
      position: 'static',
      paddingRight: 0,
      marginBottom: '5px',
      fontWeight: 300
    }
  };
});